import React, { useCallback, useEffect, useMemo, useState } from 'react';
import classes from './style.module.scss';
import List from './List';
import Button from '~/app/common/Button';
import AddMaterialDialog from './Add';
import { useStoreActions, useStoreState } from '~/store';
import useTranslation from '~/app/hooks/useTranslation';
import useAccessControl from '~/app/hooks/useAccessControl';
import { DEPARTMENT_PERMISSION_GROUPS } from '~/accessControl/permissionGroups';
import { IssueStatuses } from '~/app/data/statuses/issue';
import { IssueOrServiceType } from '~/app/data/statuses/chat';
import { ServiceStatuses } from '~/app/data/statuses/services';

export interface MaterialsProps {
  type: IssueOrServiceType
}

export type MaterialsComponent = React.FC<MaterialsProps>;

const Materials: MaterialsComponent = ({ type }) => {

  const basePath = (type === IssueOrServiceType.ISSUE )? 'issue' : 'service';
  const fetchMaterialsAction = useStoreActions(actions => actions[basePath].fetchMaterials);
  const setTempMaterialsAction = useStoreActions(actions => actions[basePath].setTempMaterials);
  const netWorkStatus = useStoreState(state => state.app.offline.status);
  const deptPrefix = useStoreState(state => state[basePath].data.departmentPrefix);
  const id = useStoreState(state => state[basePath].data.id);
  const status = useStoreState(state => state[basePath].data.status);
  const materials = useStoreState(state => state[basePath].data.materials ?? []);
  const [isOpenAddMaterialForm, setIsOpenAddMaterialForm] = useState<boolean>(false);

  const { t } = useTranslation('material');
  const { checkPermission } = useAccessControl();

  const addMaterialPermission = deptPrefix 
    ? checkPermission(DEPARTMENT_PERMISSION_GROUPS.addMatrial(deptPrefix))
    : false;

  const toggleMaterialDialog = useCallback((state: boolean) => (): void => {
    setIsOpenAddMaterialForm(state);
    if (!state) {
      setTempMaterialsAction(materials);
    }
  }, [materials, setTempMaterialsAction])

  useEffect(() => {
    if (!netWorkStatus) {
      fetchMaterialsAction(id);
    }
  }, [id, fetchMaterialsAction, netWorkStatus]);

  const isOpenStatus = useMemo(() => {
    if (type === IssueOrServiceType.ISSUE) {
      return status === IssueStatuses.REGISTERED;
    }
    if (type === IssueOrServiceType.SERVICE) {
      return status === ServiceStatuses.TRIGGERED
    }
    return false;
  }, [type, status]);

  return (
    <>
      <div className={classes['container']}>
        <div className={classes['header']}>
          <span className={classes['headerText']}>{t('parts')} ({materials?.length ?? 0})</span>
          {!netWorkStatus && isOpenStatus && addMaterialPermission && <Button className={classes['addButton']} onClick={toggleMaterialDialog(true)}>{t('add')}</Button>}
        </div>
        {materials?.length > 0 && <List type={type}/>}
        {!netWorkStatus && isOpenStatus && addMaterialPermission && <AddMaterialDialog open={isOpenAddMaterialForm} onClose={toggleMaterialDialog(false)} type={type}/>}
        <hr className={classes['bottomLine']} />
      </div>
    </>

  );
};

export default Materials
